import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "header" };
const _hoisted_3 = { class: "percentage" };
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 0,
    class: "cart"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useAppState } from '@/composables/useAppState';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGDialog from './elements/MGDialog.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaymentCompletePage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        useAuth();
        const state = useAppState();
        const { getCustomer } = useCustomer();
        const { getPayment, deleteCart, getAvailableVoucher, getCustomerVouchers } = useVouchers();
        const payment = ref(null);
        const meta = ref(null);
        const error = ref(false);
        const showFulfilmentDialog = ref(false);
        const tries = ref(0);
        let voucherPollTries = 0;
        function onLoad() {
            getCustomer();
            checkPayment();
        }
        function waitForNewVoucher() {
            getCustomerVouchers(() => {
                if (state.vouchers?.vouchers?.[0]?.isNewPurchase) {
                    router.replace({ path: "/Wallet" });
                    return;
                }
                if (voucherPollTries >= 5) {
                    showFulfilmentDialog.value = true;
                    return;
                }
                voucherPollTries += 1;
                setTimeout(waitForNewVoucher, 2000);
            }, null, false);
        }
        function goToWallet() {
            router.replace({ path: "/Wallet" });
        }
        function checkPayment() {
            getPayment(route.query.paymentId, () => {
                payment.value = state.payment;
                meta.value = JSON.parse(payment.value.requestMeta);
                deleteCart();
                getAvailableVoucher(meta.value.voucherId);
                if (payment.value.fullfillmentError) {
                    error.value = true;
                    return;
                }
                if (payment.value.fulfilled) {
                    waitForNewVoucher();
                    return;
                }
                else {
                    setTimeout(() => {
                        tries.value += 1;
                        if (tries.value >= 6) {
                            error.value = true;
                            return;
                        }
                        checkPayment();
                    }, 5000);
                }
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Voucher",
                    color: "white",
                    bgcolor: "#281C3Bee",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: payment.value
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).availableVoucher && !error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", {
                                    class: "header-image",
                                    style: _normalizeStyle('background-image: url(' + _unref(state).availableVoucher.cardUrl + ')')
                                }, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, { class: "v-col-9" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("h1", null, _toDisplayString(_unref(state).availableVoucher.merchant.name), 1),
                                                        _createElementVNode("p", null, _toDisplayString(_unref(state).availableVoucher.description.substring(0, 200)) + "...", 1),
                                                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(state).availableVoucher.effectiveDiscountPercentage) + "% cashback", 1),
                                                        (_unref(state).availableVoucher.online)
                                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                key: 0,
                                                                variant: "outlined",
                                                                "background-color": "blue"
                                                            }, {
                                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                                    _createTextVNode("Online")
                                                                ])),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true),
                                                        _cache[4] || (_cache[4] = _createTextVNode()),
                                                        (_unref(state).availableVoucher.inStore)
                                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                key: 1,
                                                                variant: "outlined"
                                                            }, {
                                                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                                    _createTextVNode("In Store")
                                                                ])),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_col, { class: "v-col-3 logo-col" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                            src: _unref(state).availableVoucher.merchant.logoUrl
                                                        }, null, 8, _hoisted_4)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ], 4)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (payment.value && meta.value && meta.value.type == 'voucher' && !error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Payment Complete", -1)),
                                _cache[6] || (_cache[6] = _createElementVNode("p", null, "Ordering your retail card . . .", -1)),
                                _createVNode(_component_v_progress_circular, {
                                    class: "mt-10",
                                    indeterminate: ""
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(MGDialog, {
                    modelValue: error.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((error).value = $event)),
                    title: "Fulfilment Error",
                    maxWidth: "400px",
                    contentHeight: "auto",
                    persistent: ""
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", null, "We are very sorry, there was an issue fulfilling your order with " + _toDisplayString(_unref(state).availableVoucher?.merchant?.name) + ". Please contact help@moneyguided.com", 1)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Continue",
                            onClick: goToWallet
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showFulfilmentDialog.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((showFulfilmentDialog).value = $event)),
                    title: "Fulfilment Issue",
                    maxWidth: "400px",
                    contentHeight: "auto",
                    persistent: ""
                }, {
                    content: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("p", null, "We're sorry - there has been an issue fulfilling your voucher order, our team has been informed and will contact you regarding refunds and next steps.", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Continue",
                            onClick: goToWallet
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
